<template>
    <b-row>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <b-card class="sa-card sa-card-border" header="Valutazione Dermatologica" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Decubiti</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneDermatologica.decubiti }}</span>
                        <b-form-input v-else v-model="jsonDataValutazioneDermatologica.decubiti" :disabled="isReadOnly"> </b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Mucosa</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneDermatologica.mucose }}</span>
                        <b-form-select v-else v-model="jsonDataValutazioneDermatologica.mucose" :options="mucoseOptions" :disabled="isReadOnly">
                            <template #first>
                                <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Mucose descrizione</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneDermatologica.mucoseDescrizione }}</span>
                        <b-form-input v-else v-model="jsonDataValutazioneDermatologica.mucoseDescrizione" :disabled="isReadOnly"> </b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Cute: </label>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <b-row>
                                <b-col cols="auto" v-for="cute in cuteOptions" :key="'cute-' + cute.id" class="sa-switch-select-element">
                                    <b-form-checkbox switch :disabled="isReadOnly" v-model="selectedCute" :value="cute.voce" @change="onSelectCheckBox">
                                        <span style="font-weight: normal">{{ cute.voce }}</span>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Unghie: </label>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <b-row>
                                <b-col cols="auto" v-for="unghie in unghieOptions" :key="'unghie-' + unghie.id" class="sa-switch-select-element">
                                    <b-form-checkbox switch :disabled="isReadOnly" v-model="selectedUnghie" :value="unghie.voce" @change="onSelectCheckBox">
                                        <span style="font-weight: normal">{{ unghie.voce }}</span>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Note</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneDermatologica.note }}</span>
                        <b-form-textarea v-else v-model="jsonDataValutazioneDermatologica.note" :readonly="isReadOnly" max-rows="10" rows="5"> </b-form-textarea>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    mixins: [UtilityMixin],
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataValutazioneDermatologica: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    decubiti: "",
                    mucose: "",
                    mucoseDescrizione: "",
                    note: "",
                    listaDermatologaCute: [],
                    listaDermatologaUnghie: [],
                };
            },
        },
    },
    mounted() {
        let me = this;
        // me.loadValutazioneDermatologicaData();
        me.loadDizionarioData();
        // me.popolaArrayDaListe();
        // console.log("MOUNTED DEL 4° LIVELLO, PRENDO OGGETTO NELLA PROPS: [4° LIVELLO] con il seguente jsonDataValutazioneDermatologica:", me.jsonDataValutazioneDermatologica);

        // console.log("dizionario");
    },
    watch: {
        jsonDataValutazioneDermatologica: {
            handler(jsonData) {
                this.$emit("update", jsonData);
                // console.log("JSON ALL INTERNO DEL WATCH [4° LIVELLO] con il seguente jsonDataValutazioneDermatologica: ", this.jsonDataValutazioneDermatologica);

                this.popolaArrayDaListe();
            },
            deep: true,
        },
        /* jsonDataValutazioneDermatologica: {
            handler(newVal, oldVal) {
                if (newVal && newVal.id && (!oldVal || !oldVal.id)) {
                    this.popolaArrayDaListe();
                }
            },
            deep: true,
            immediate: true, // Esegue anche al primo caricamento
        }, */
    },
    data() {
        return {
            pathResourceSchedaInfermieristicaValutazioneDermatologica: "/rsaschedainfermieristicavalutazionedermatologica",
            pathResourceDizionario: "/rsadizionario",
            cuteOptions: [],
            selectedCute: [],
            unghieOptions: [],
            selectedUnghie: [],
            mucoseOptions: [
                { text: "INTEGRE", value: "INTEGRE" },
                { text: "LESIONI", value: "LESIONI" },
            ],
        };
    },
    methods: {
        popolaArrayDaListe() {
            let me = this;
            // console.log("STO INIZIANDO A FARE IL POPOLAMENTO NEL METODO popolaArrayList del [4° LIVELLO] con il seguente jsonDataValutazioneDermatologica:", this.jsonDataValutazioneDermatologica);
            me.selectedCute = [];
            me.selectedUnghie = [];

            if (me.jsonDataValutazioneDermatologica.listaDermatologaCute.length > 0) {
                // console.log("SONO ALL'INTERNO DELLA CONDIZIONE IF DEL METODO popoLAarray del [4° LIVELLO], entro se ho: ", me.jsonDataValutazioneDermatologica.listaDermatologaCute);
                // console.log("me.jsonDataValutazioneDermatologica.listaDermatologaCute.length: ", me.jsonDataValutazioneDermatologica.listaDermatologaCute.length);

                me.jsonDataValutazioneDermatologica.listaDermatologaCute.forEach((item) => {
                    if (item.tipo === "CUTE") {
                        me.selectedCute.push(item.voce);
                    }
                });
            }

            if (me.jsonDataValutazioneDermatologica.listaDermatologaUnghie.length > 0) {
                me.jsonDataValutazioneDermatologica.listaDermatologaUnghie.forEach((item) => {
                    if (item.tipo === "UNGHIE") {
                        me.selectedUnghie.push(item.voce);
                    }
                });
            }
            // console.log("FINE POPOLAMENTO [4° LIVELLO], CUTE: ", me.jsonDataValutazioneDermatologica.listaDermatologaCute, " UNGHIE:", me.jsonDataValutazioneDermatologica.listaDermatologaUnghie);
        },
        loadDizionarioData() {
            let me = this;
            me.$emit("beforeLoadData");
            UtilityMixin.methods.loadDataResources(me.pathResourceDizionario, null, me.loadDataDizionarioSuccess, me.loadDataDizionarioError);
        },
        loadDataDizionarioSuccess(response) {
            let me = this;
            if (response.data?.data?.list) {
                me.cuteOptions = response.data.data.list.filter((item) => item.tipo === "CUTE");
                me.unghieOptions = response.data.data.list.filter((item) => item.tipo === "UNGHIE");
            }
            // console.log("UNGHIE:", me.unghieOptions);
        },
        onSelectCheckBox() {
            let me = this;
            let listaDermatologaCute = [];
            me.selectedCute.forEach((voce) => {
                listaDermatologaCute.push({
                    id: null,
                    idSchedaInfermieristicaValutazioneDermatologica: me.jsonDataValutazioneDermatologica.id,
                    tipo: "CUTE",
                    voce: voce,
                });
            });
            me.jsonDataValutazioneDermatologica.listaDermatologaCute = listaDermatologaCute;
            // console.log("CUTE", me.jsonDataValutazioneDermatologica.listaDermatologaCute);
            // console.log("SELECTEDCUTE", me.selectedCute);

            let listaDermatologaUnghie = [];
            me.selectedUnghie.forEach((voce) => {
                listaDermatologaUnghie.push({
                    id: null,
                    idSchedaInfermieristicaValutazioneDermatologica: me.jsonDataValutazioneDermatologica.id,
                    tipo: "UNGHIE",
                    voce: voce,
                });
            });
            me.jsonDataValutazioneDermatologica.listaDermatologaUnghie = listaDermatologaUnghie;
            // console.log("unghie", me.jsonDataValutazioneDermatologica.listaDermatologaUnghie);
        },

        /*  loadValutazioneDermatologicaData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaInfermieristicaValutazioneDermatologica + "/accettazione/" + me.idAccettazione, null, me.resultResponseSchedaInfermieristicaValutazioneDermatologicaSuccess, me.resultResponseSchedaInfermieristicaValutazioneDermatologicaError);
        },
        resultResponseSchedaInfermieristicaValutazioneDermatologicaSuccess(response) {
            let me = this;
            // me.jsonDataValutazioneDermatologica = response.data.data;
            Object.keys(response.data.data).forEach((key) => {
                me.jsonDataValutazioneDermatologica[key] = response.data.data[key];
            });
            me.selectedCute = [];
            me.selectedUnghie = [];

            me.jsonDataValutazioneDermatologica.listaDermatologaCute.forEach((item) => {
                if (item.tipo === "CUTE") {
                    me.selectedCute.push(item.voce);
                }
            });

            me.jsonDataValutazioneDermatologica.listaDermatologaUnghie.forEach((item) => {
                if (item.tipo === "UNGHIE") {
                    me.selectedUnghie.push(item.voce);
                }
            });
        }, */
        resultResponseSchedaInfermieristicaValutazioneDermatologicaError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                //console.log("NESSUN record trovato del VALUTAZIONE DERMATOLOGICA per questo id accettazione");
                me.resetForm();
            } else {
                console.error("Errore nel caricamento dati della sezione VALUTAZIONE DERMATOLOGICA:", error);
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataValutazioneDermatologica = {
                id: null,
                idAccettazione: me.idAccettazione,
                decubiti: null,
                mucose: null,
                mucoseDescrizione: null,
                note: null,
                listaDermatologaCute: [],
                listaDermatologaUnghie: [],
            };

            me.selectedCute = [];
            me.selectedUnghie = [];
        },

        onSalvaValutazioneDermatologica() {
            let me = this;
            me.jsonDataValutazioneDermatologica.idAccettazione = me.idAccettazione;
            // console.log("Salvataggio VALUTAZIONE DERMATOLOGICA con dati:", JSON.stringify(me.jsonDataValutazioneDermatologica));
            if (!me.jsonDataValutazioneDermatologica.idAccettazione) {
                // console.log("idAccettazione: ", me.jsonDataValutazioneDermatologica.idAccettazione);
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }

            let listaDermatologaCute = [];
            me.selectedCute.forEach((voce) => {
                listaDermatologaCute.push({
                    id: null,
                    idSchedaInfermieristicaValutazioneDermatologica: me.jsonDataValutazioneDermatologica.id,
                    tipo: "CUTE",
                    voce: voce,
                });
            });

            let listaDermatologaUnghie = [];
            me.selectedUnghie.forEach((voce) => {
                listaDermatologaUnghie.push({
                    id: null,
                    idSchedaInfermieristicaValutazioneDermatologica: me.jsonDataValutazioneDermatologica.id,
                    tipo: "UNGHIE",
                    voce: voce,
                });
            });
            me.jsonDataValutazioneDermatologica.listaDermatologaCute = listaDermatologaCute;
            me.jsonDataValutazioneDermatologica.listaDermatologaUnghie = listaDermatologaUnghie;

            UtilityMixin.methods.saveResource(me.pathResourceSchedaInfermieristicaValutazioneDermatologica, me.jsonDataValutazioneDermatologica, me.saveValutazioneDermatologicaSuccessResponse, me.saveValutazioneDermatologicaErrorResponse);
        },
        saveValutazioneDermatologicaSuccessResponse(response) {
            let me = this;
            console.log("VALUTAZIONE DERMATOLOGICA salvato con successo:", response, me.jsonDataValutazioneDermatologica);
        },
        saveValutazioneDermatologicaErrorResponse() {
            /* console.error("Errore nel salvataggio VALUTAZIONE DERMATOLOGICA:", error); */
        },
    },
};
</script>
